import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-the-j05-chat-screen-panel-message__icon"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "p-the-j05-chat-screen-panel-message__time"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconUserImage = _resolveComponent("IconUserImage")!
  const _component_SmallText = _resolveComponent("SmallText")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      _ctx.classNameBase.rootElement,
      `${_ctx.classNameBase.rootElement}${_ctx.classNameDirection[_ctx.isYouSent]}`
    ])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
        _ctx.classNameBase.col,
        `${_ctx.classNameBase.col}${_ctx.classNameDirection[_ctx.isYouSent]}`
      ])
    }, [
      (!_ctx.isYouSent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_IconUserImage, { size: 32 }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _ctx.partnerUserImage,
                  alt: ""
                }, null, 8, _hoisted_2)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass([
          _ctx.classNameBase.message,
          `${_ctx.classNameBase.message}${_ctx.classNameDirection[_ctx.isYouSent]}`
        ])
      }, [
        _renderSlot(_ctx.$slots, "content", {}, undefined, true)
      ], 2),
      (_ctx.nextItemTime !== _ctx.time)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_SmallText, {
              color: "#333333",
              size: _ctx.timeTextFontSize
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.time), 1)
              ]),
              _: 1
            }, 8, ["size"])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}